// extracted by mini-css-extract-plugin
export default {"root":"classes_root__FloWc","title-container":"classes_title-container__CvkGO"};